"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodePageSize = 256;
//# sourceMappingURL=constants.js.map